import { render, staticRenderFns } from "./SparePartsSvg.vue?vue&type=template&id=1288d9f2&"
import script from "./SparePartsSvg.vue?vue&type=script&lang=js&"
export * from "./SparePartsSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports